import { PageHero } from '../components/ui/PageHero';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { CTAButton } from '../components/ui/CTAButton';
import { SectionLink } from '../components/ui/SectionLink';
import { MEDITATION_PROGRAMS } from '../constants/content';
import { meditationPath } from '../constants/navigation';

export default function MeditationPage() {
  return (
    <>
      <PageHero
        title="冥想课程"
        subtitle="从 5 分钟呼吸练习到 30 分钟深度旅程，根据你的时间与状态选择合适课程。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '冥想课程' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="space-y-12 max-w-4xl mx-auto">
          {MEDITATION_PROGRAMS.map((program) => (
            <AnimatedCard
              key={program.id}
              className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-purple-500/20"
            >
              <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
                <h2 className="text-2xl font-bold">{program.title}</h2>
                <div className="flex gap-2">
                  <span className={`text-xs ${program.badgeClass} text-light px-3 py-1 rounded-full`}>
                    {program.badge}
                  </span>
                  <span className="text-xs bg-white/10 text-purple-300 px-3 py-1 rounded-full">
                    {program.duration}
                  </span>
                  <span className="text-xs bg-secondary/20 text-light px-3 py-1 rounded-full">
                    {program.difficulty}
                  </span>
                </div>
              </div>
              <p className="text-purple-200 mb-2">{program.desc}</p>
              <p className="text-purple-400 text-sm mb-6">{program.scene}</p>

              <h3 className="text-sm font-semibold text-secondary mb-3">课程结构（节选）</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
                {program.sections.slice(0, 4).map((sec) => (
                  <div
                    key={sec.name}
                    className="bg-darker/40 rounded-xl p-4 border border-purple-500/10"
                  >
                    <p className="font-medium text-sm mb-1">{sec.name}</p>
                    <p className="text-purple-300 text-xs">{sec.meaning}</p>
                  </div>
                ))}
              </div>

              <SectionLink to={meditationPath(program.id)}>查看完整课程指南</SectionLink>
            </AnimatedCard>
          ))}
        </div>

        <div className="text-center mt-16">
          <p className="text-purple-200 mb-6">选择主题后，APP 会推荐匹配的冥想课程</p>
          <CTAButton to="/guide" variant="primary" size="lg" icon="fa-play">
            开始冥想练习
          </CTAButton>
        </div>
      </section>
    </>
  );
}
